import React, { FC } from 'react'

import { EuiTitle, EuiFlexGroup, EuiFlexItem, EuiHorizontalRule, EuiButton, EuiButtonIcon, EuiToolTip } from '@elastic/eui'

export interface PersonaPageHeaderProps {
  pageTitle?: string
  onEditPageTitle?: () => void
  showActions?: boolean
  onClientPdfClick?: () => void
  isGeneratingPdf?: boolean
  onAllClientPdfsClick?: () => void
  onAllStaffPdfsClick?: () => void
  staffPdfDisabledReason?: string
}

const PersonaPageHeader: FC<PersonaPageHeaderProps> = ({ pageTitle, onEditPageTitle, showActions = false, onClientPdfClick, isGeneratingPdf, onAllClientPdfsClick, onAllStaffPdfsClick, staffPdfDisabledReason }) => {
  const title = pageTitle || 'Persona Prioritization'

  return (
    <>
      <EuiFlexGroup justifyContent='spaceBetween'>
        <EuiFlexItem grow={false}>
          <EuiFlexGroup alignItems='center' gutterSize='s' responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiTitle size='m'>
                <h3>{title}</h3>
              </EuiTitle>
            </EuiFlexItem>
            {showActions && onEditPageTitle && (
              <EuiFlexItem grow={false}>
                <EuiButtonIcon iconType='pencil' onClick={onEditPageTitle} aria-label='Edit title' />
              </EuiFlexItem>
            )}
          </EuiFlexGroup>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiFlexGroup>
            {onAllStaffPdfsClick && (
              <EuiFlexItem grow={false}>
                {staffPdfDisabledReason ? (
                  <EuiToolTip content={staffPdfDisabledReason}>
                    <EuiButton size='s' color='primary' disabled>
                      All Staff PDFs
                    </EuiButton>
                  </EuiToolTip>
                ) : (
                  <EuiButton size='s' color='primary' onClick={onAllStaffPdfsClick}>
                    All Staff PDFs
                  </EuiButton>
                )}
              </EuiFlexItem>
            )}
            {false && onAllClientPdfsClick && (
              <EuiFlexItem grow={false}>
                <EuiButton size='s' color='primary' onClick={onAllClientPdfsClick}>
                  All Client PDFs
                </EuiButton>
              </EuiFlexItem>
            )}
            {onClientPdfClick && (
              <EuiFlexItem grow={false}>
                <EuiButton size='s' color='primary' onClick={onClientPdfClick} isLoading={isGeneratingPdf} disabled={isGeneratingPdf}>
                  Client PDF
                </EuiButton>
              </EuiFlexItem>
            )}
          </EuiFlexGroup>
        </EuiFlexItem>
      </EuiFlexGroup>
      <EuiHorizontalRule />
    </>
  )
}

export default PersonaPageHeader
